import { addTableFields } from './addTableFields';

export const prepareExportUrl = (requestUrl, tableFields) => {
  const delimiter = requestUrl.includes('?') ? '&' : '?';

  return requestUrl + delimiter + 'return_type=xlsx' + addTableFields(tableFields);
};